// /context/UserContext.js
import React, {createContext, useContext, useEffect, useState} from 'react';
import axiosService from '../components/Utilities/axiosService';

const UserContext = createContext();

export const UserProvider = ({children}) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axiosService.get('/user/GetCurrentUser'); // Adjust endpoint as needed
                setUser(response.data);
            } catch (error) {
                console.error('Failed to fetch user:', error);
                if (error.code === "ERR_NETWORK" || error.code === "ERR_BAD_REQUEST") {
                    if (window.location.pathname !== '/server-outage') {
                        window.location.replace('/server-outage');
                    }
                }
                return Promise.reject(error);
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    return (
        <UserContext.Provider value={{user, loading}}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
